export const getScrollParent = (element: HTMLElement): HTMLElement => {
  for (let parent = element.parentElement; parent; parent = parent.parentElement) {
    const { overflowY } = window.getComputedStyle(parent)
    const scrolls = overflowY === 'auto' || overflowY === 'scroll'
    if (scrolls && parent.scrollHeight > parent.clientHeight) {
      return parent
    }
  }
  return document.documentElement
}

export const getStickyOffset = (element: HTMLElement): number => {
  const { position, top } = window.getComputedStyle(element)
  if (position !== 'sticky') return 0
  return parseFloat(top) || 0
}
